<template>
    <div id="notification-users-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add User to {{ notification ? notification.name : '' }}</h5>
                </div>
                <div class="modal-body">
                    <div v-if="notification && notification.type == 'periodic'">
                        <label for="recurrence">Recurrence:</label>
                        <select id="recurrence" class="custom-select custom-select-sm" style="width:auto;" v-model="param">
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                            <option value="quarterly">Quarterly</option>
                        </select>
                    </div>
                    <div v-if="users && users.length" class="list-group list-group-scroll mt-2">
                        <template v-for="user in users">
                            <button type="button" class="list-group-item list-group-item-action" :key="'user-' + user.id" @click="add(user.id)">              
                                <div style="line-height: 1">{{ user.full_name }}</div>
                                <div style="line-height: 1"><small>{{ user.email }}</small></div>
                            </button>
                        </template>
                    </div>
                    <div v-else class="mt-3">
                        <h5>No users available to add.</h5>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            users: [],
            notification: null,
            param: null
        }
    },
    methods: {
        show: function (filteredUsers, notification) {
            this.users = filteredUsers;
            this.notification = notification;

            switch(notification.type) {
                case 'periodic':
                    this.param = 'daily';
                    break;
                default:
                    this.param = null;
            }

            $('#notification-users-modal').modal('show');
        },
        add: function (id) {
            axios.post('/ajax/admin/notifications/users/' + id, {
                'notification_id': this.notification.id,
                'param': this.param
            })
            .then(response => {
                this.$emit('callback');
                $('#notification-users-modal').modal('hide');
            })
            .catch(error => {
                console.log(error.response.data);
                $('#notification-users-modal').modal('hide');
            });
        }
    },
    created() {
        eventHub.$on('add-notification-user', this.show);        
    },
    beforeDestroy() {
        eventHub.$off('add-notification-user');
    }    
}
</script>

<style scoped>
    .list-group-scroll {
        max-height: 500px; 
        overflow: scroll; 
        -webkit-overflow-scrolling: touch;
    }
</style>